import io from 'socket.io-client';
import store from 'store';

let instances = null;

/**
 * Funkcja uruchamiająca wszystkie sockety dla napiwków, konfiguracji oraz szablonów.
 *
 * @param {function} tipCallback
 * @param {function} moderationCallback
 * @param {function} commandsCallback
 * @param {function} moderationUpdatedCallback panel-only sync (approve/reject/restore)
 * @returns {object}
 */
export default function sockets(
  tipCallback = null,
  moderationCallback = null,
  commandsCallback = null,
  moderationUpdatedCallback = null,
) {
  const { userData } = store.getState();
  const { tipsModeration } = store.getState();

  let uid = userData.info.id ? userData.info.id : null;
  const mid = tipsModeration.currentModerator ? tipsModeration.currentModerator.user_id : null;

  if (uid === null && mid) {
    uid = mid;
  }

  if (!instances) {
    instances = {
      tip: io(`${process.env.REACT_APP_SOCKET_URL}/tip/${uid}`),
      moderation: io(`${process.env.REACT_APP_SOCKET_URL}/moderation/${uid}`),
      commands: io(`${process.env.REACT_APP_SOCKET_URL}/commands/${uid}`),
    };
  }

  const emptyCallback = () => {};

  return {
    on() {
      instances.tip.on('tip', tipCallback || emptyCallback);
      instances.moderation.on('moderation', moderationCallback || emptyCallback);
      instances.moderation.on('moderation_updated', moderationUpdatedCallback || emptyCallback);
      instances.commands.on('commands', commandsCallback || emptyCallback);
    },
    off() {
      instances.tip.off('tip', tipCallback || emptyCallback);
      instances.moderation.off('moderation', moderationCallback || emptyCallback);
      instances.moderation.off('moderation_updated', moderationUpdatedCallback || emptyCallback);
      instances.commands.off('commands', commandsCallback || emptyCallback);
    },
  };
}
